import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {URL} from '../_mocks/url';
import {LastActivity} from '../_classes/lastActivity';

@Injectable()
export class LastActivityService {

  private urlLastActivity = URL + 'last-activity';

  constructor(private http: HttpClient) {

  }

  retrieve(): Observable<LastActivity> {
    return this.http.get<LastActivity>(
      this.urlLastActivity, {
        headers: new HttpHeaders({'Content-Type': 'application/json'}),
        responseType: 'json'
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/last-activity.service.ts